export const CONTACT = {
  phone: "+91 99021 62130",
  phoneRaw: "+919902162130",
  whatsapp: "https://wa.me/919902162130",
  email: "sanjith@abcguitarlessons.com",
};

export const LANGUAGES = ["English", "Hindi", "Malayalam"];

export const SOCIALS = {
  spotify: "https://open.spotify.com/artist/5n8lr8PgTJJBhbL4VY1CDV",
  youtube: "https://www.youtube.com/@sanjithiswalterbrown",
  instagram: "https://instagram.com/wltrbrown",
};

export const MARQUEE_TOPICS = [
  "Pop Theory", "Fingerpicking", "Circle of Fifths", "Blues & Jazz",
  "Nashville Numbers", "Bollywood & Beyond", "4 Songs 4 Weeks", "Modes & Scales",
  "Home Recording", "Capo Mastery", 
];

export const COURSES = [
  {
    id: "indie",
    tag: "Advanced · Deep Dive",
    name: "The Ultimate Indie Musician Guitar Course",
    price: "₹9,999",
    image: "/photos/songs-course.webp",
    vinyl: "/audio/vinyl-2.mp3",
    blurb:
      "Everything I have learnt over the last 6 years as a teacher and student of music — summed up in one unforgettable month.",
    meta: [
      ["9", "Sessions"],
      ["1", "Month"],
      ["9", "Topics"],
      ["Live", "Online"],
    ],
    topics: [
      "Pop Music Theory", "Forming Chords", "Triads, Scales & Modes",
      "Fingerpicking", "Capo Mastery", "Circle of Fifths",
      "Blues & Jazz", "Nashville Numbers", "Home Recording",
    ],
    needs: ["Laptop", "Any Guitar", "Internet", "Love for Music"],
  },
  {
    id: "songs",
    tag: "Beginner Friendly",
    name: "4 Songs 4 Weeks",
    price: "₹4,999",
    image: "/photos/bw-electric.webp",
    vinyl: "/audio/vinyl-1.mp3",
    blurb:
      "An interactive online course focused on learning 4 songs on guitar in one month. Chord charts and class materials included.",
    meta: [
      ["8", "Sessions"],
      ["1", "Month"],
      ["4", "Songs"],
      ["Live", "Online"],
    ],
    songs: [
      { n: "01", title: "Welcome to Paradise", by: "Green Day · Power chords & basic rhythms", genre: "Punk Rock" },
      { n: "02", title: "House of the Rising Sun", by: "The Animals · Pick control with open chords", genre: "Blues" },
      { n: "03", title: "Get Lucky", by: "Daft Punk · Funk rhythms & barre chords", genre: "Pop / Funk" },
      { n: "04", title: "Your Choice", by: "Bring in something you want to play", genre: "Any ✦" },
    ],
    needs: ["Laptop", "Any Guitar", "Internet"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Sanjith sir taught music by including my brother's and my favourite music into the curriculum, he lead us patiently as we tried to understand what built up the music we love, and then he connected it to musical theories. My foundation in music is concrete because of the connections he made me see: not isolated theory or songs, but both a part of each other. Sanjith sir's approach to teaching his students is ingrained with both empathy and patience, while motivating us to go beyond him. Thank you Sanjith sir for your jam sessions, pep talks, and your infectious passion in music.",
    name: "Kaushal Shah",
    detail: "Age 18 · Student since 2023",
    image: "/testimonials/kaushal.jpg",
  },
  {
    quote:
      "Sanjith has an excellent ability to teach guitar in a clear, patient, and engaging manner. His approach makes it easy for students to understand the fundamental concepts and basic music theory behind guitar playing. By breaking down complex topics into simple, practical lessons, he helps learners build a strong foundation and gain confidence in their playing. His teaching style encourages steady progress and makes learning enjoyable for students of all levels.",
    name: "Arun",
    detail: "Age 47 · The Ultimate Indie Musician Guitar Course",
    image: "/testimonials/arun.jpg",
  },
];

export const MEDIA_SAMPLES = [
  { type: "audio", title: "Composition in A♯m", meta: "Original · 1:09", src: "/audio/listen-aminor.mp3" },
  { type: "audio", title: "Composition in E Major", meta: "Original · 1:02", src: "/audio/listen-emajor.mp3" },
  { type: "audio", title: "Funky Beat", meta: "Groove · 1:13", src: "/audio/listen-funky.mp3" },
];

export const VIDEO_SAMPLES = [
  {
    title: "Arpeggios on One String — Fretboard Knowledge",
    subtitle: "Teaching · 5:26",
    src: "/videos/arpeggios.mp4",
    poster: "/videos/arpeggios-poster.jpg",
  },
  {
    title: "Live Performance — Snippet",
    subtitle: "Live · 2:27",
    src: "/videos/live-performance.mp4",
    poster: "/videos/live-performance-poster.jpg",
    portrait: true,
  },
  {
    title: "Improvisation in B♭m — Grade 6 Electric",
    subtitle: "Recital · 1:04",
    src: "/videos/improvisation.mp4",
    poster: "/videos/improvisation-poster.jpg",
  },
];

export const TIME_SLOTS = ["10:00 AM", "12:00 PM", "4:00 PM", "6:00 PM", "8:00 PM"];

export const FAQS = [
  {
    q: "When are the classes held?",
    a: "Class timings are 7:30 PM IST on Thursdays and 11 AM IST on Saturdays.",
  },
  {
    q: "Are the classes in person or online?",
    a: "Online, taught as a group. The size of the group does not affect the quality of the instruction — the study materials provided give a structured way of following the class. The Ultimate Indie Musician Guitar Course is structured as an all-inclusive crash course which gives tools for indie musicians to use in their own composition.",
  },
  {
    q: "What equipment do I need?",
    a: "Any guitar — acoustic or electric — a laptop or phone with a stable internet connection, and a love for music. No fancy gear, no prior theory. Chord charts and class materials are provided.",
  },
  {
    q: "What if I miss a class?",
    a: "Life happens. Find a video recording of the class in the student login.",
  },
  {
    q: "What's your refund policy?",
    a: "Full refund if you cancel up to three days before your first session.",
  },
];
